document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initBundle();
  initFaq();
  initNieve();
  initBarraFija();
  initCuentaOferta();
  initCarrusel();
  initContadorGente();
});

function initReveal() {
  var els = document.querySelectorAll('.mc-reveal, .mc-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mc-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mc-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-mc-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mc-imagen-principal]');
    var minis = Array.prototype.slice.call(galeria.querySelectorAll('[data-mc-miniatura]'));
    if (!principal || !minis.length) return;

    function mostrar(indice) {
      var mini = minis[indice];
      var src = mini.getAttribute('data-mc-src');
      var srcset = mini.getAttribute('data-mc-srcset');
      if (!src) return;
      principal.src = src;
      if (srcset) principal.srcset = srcset;
      minis.forEach(function (m) { m.classList.remove('mc-activa'); });
      mini.classList.add('mc-activa');
    }

    var indiceActual = 0;
    var auto;
    function reiniciarAuto() {
      if (auto) clearInterval(auto);
      if (minis.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      auto = setInterval(function () {
        indiceActual = (indiceActual + 1) % minis.length;
        mostrar(indiceActual);
      }, 3500);
    }

    minis.forEach(function (mini, indice) {
      mini.addEventListener('click', function () {
        indiceActual = indice;
        mostrar(indiceActual);
        reiniciarAuto();
      });
    });

    reiniciarAuto();
  });
}

function initBundle() {
  document.querySelectorAll('[data-mc-producto]').forEach(function (form) {
    var opciones = Array.prototype.slice.call(form.querySelectorAll('[data-mc-bundle-opcion]'));
    var qtyInput = form.querySelector('[data-mc-cantidad]');
    var varianteInput = form.querySelector('input[name="id"]');
    if (!opciones.length || !qtyInput) return;

    function aplicarVariante(op) {
      var select = op.querySelector('[data-mc-adaptador]');
      if (select && varianteInput) varianteInput.value = select.value;
    }

    opciones.forEach(function (op) {
      op.addEventListener('click', function () {
        opciones.forEach(function (o) { o.classList.remove('mc-seleccionada'); });
        op.classList.add('mc-seleccionada');
        var input = op.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        qtyInput.value = op.getAttribute('data-mc-cantidad-valor') || 1;
        aplicarVariante(op);
      });

      var select = op.querySelector('[data-mc-adaptador]');
      if (select) {
        select.addEventListener('change', function () {
          if (op.classList.contains('mc-seleccionada')) aplicarVariante(op);
        });
      }
    });
  });
}

function initContadorGente() {
  document.querySelectorAll('[data-mc-contador-gente]').forEach(function (caja) {
    var texto = caja.querySelector('[data-mc-contador-gente-texto]');
    var plantilla = caja.getAttribute('data-plantilla') || '{n} personas viendo esto ahora';
    var actual = parseInt(caja.getAttribute('data-inicial'), 10) || 18;
    var maximo = parseInt(caja.getAttribute('data-maximo'), 10) || 42;
    var incremento = parseInt(caja.getAttribute('data-incremento'), 10) || 2;
    var intervaloSeg = parseInt(caja.getAttribute('data-intervalo'), 10) || 15;

    function pintar() {
      if (texto) texto.textContent = plantilla.replace('{n}', actual);
    }

    pintar();
    if (actual >= maximo) return;

    var intervalo = setInterval(function () {
      actual = Math.min(maximo, actual + incremento);
      pintar();
      if (actual >= maximo) clearInterval(intervalo);
    }, intervaloSeg * 1000);
  });
}

function initNieve() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-mc-nieve]').forEach(function (capa) {
    var cantidad = parseInt(capa.getAttribute('data-mc-nieve'), 10) || 18;
    for (var i = 0; i < cantidad; i++) {
      var copo = document.createElement('span');
      copo.className = 'mc-copo';
      copo.textContent = Math.random() > 0.5 ? '❆' : '❅';
      copo.style.left = (Math.random() * 100) + '%';
      copo.style.fontSize = (14 + Math.random() * 20) + 'px';
      copo.style.animationDuration = (9 + Math.random() * 10) + 's';
      copo.style.animationDelay = (Math.random() * -18) + 's';
      capa.appendChild(copo);
    }
  });
}

function initBarraFija() {
  var barra = document.querySelector('[data-mc-barra-fija]');
  var objetivo = document.querySelector('#mc-comprar');
  var pie = document.querySelector('footer.footer');
  if (!barra || !objetivo || typeof IntersectionObserver === 'undefined') return;

  var compraVisible = false;
  var pieVisible = false;

  function actualizarBarra() {
    if (compraVisible || pieVisible) {
      barra.classList.remove('mc-visible');
    } else {
      barra.classList.add('mc-visible');
    }
  }

  if (pie) {
    var obsPie = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        pieVisible = entry.isIntersecting;
        actualizarBarra();
      });
    }, { threshold: 0, rootMargin: '0px 0px -1px 0px' });
    obsPie.observe(pie);
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        compraVisible = true;
        actualizarBarra();
      } else if (entry.boundingClientRect.top < 0) {
        compraVisible = false;
        actualizarBarra();
      } else {
        compraVisible = false;
        actualizarBarra();
      }
    });
  }, { threshold: 0 });
  obs.observe(objetivo);
}

function initCuentaOferta() {
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  document.querySelectorAll('[data-mc-cuenta-oferta]').forEach(function (caja) {
    var fechaTexto = caja.getAttribute('data-mc-cuenta-oferta');
    var dias = caja.querySelector('[data-mc-dias]');
    var horas = caja.querySelector('[data-mc-horas]');
    var min = caja.querySelector('[data-mc-min]');
    var seg = caja.querySelector('[data-mc-seg]');
    if (!fechaTexto || !dias) return;
    var objetivo = new Date(fechaTexto);
    if (isNaN(objetivo.getTime())) return;
    var intervalo;
    function actualizar() {
      var diff = objetivo.getTime() - Date.now();
      if (diff <= 0) {
        caja.style.display = 'none';
        if (intervalo) clearInterval(intervalo);
        return;
      }
      dias.textContent = pad(Math.floor(diff / 86400000));
      horas.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      min.textContent = pad(Math.floor((diff % 3600000) / 60000));
      seg.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    actualizar();
    intervalo = setInterval(actualizar, 1000);
  });
}

function initCarrusel() {
  document.querySelectorAll('[data-mc-carrusel]').forEach(function (wrap) {
    var pista = wrap.querySelector('[data-mc-carrusel-pista]');
    var prev = wrap.querySelector('[data-mc-carrusel-prev]');
    var next = wrap.querySelector('[data-mc-carrusel-next]');
    var puntos = Array.prototype.slice.call(wrap.querySelectorAll('[data-mc-carrusel-punto]'));
    if (!pista || !prev || !next) return;

    function tarjetas() {
      return Array.prototype.slice.call(pista.children);
    }

    function paso() {
      var tarjeta = pista.querySelector('.mc-resena-card, .mc-video-item');
      if (!tarjeta) return pista.clientWidth;
      var estilo = getComputedStyle(pista);
      return tarjeta.getBoundingClientRect().width + parseFloat(estilo.gap || 18);
    }

    function actualizarFlechas() {
      var maxScroll = pista.scrollWidth - pista.clientWidth - 2;
      prev.disabled = pista.scrollLeft <= 2;
      next.disabled = pista.scrollLeft >= maxScroll;
    }

    function actualizarPuntos() {
      if (!puntos.length) return;
      var lista = tarjetas();
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var indiceCercano = 0;
      var distanciaMinima = Infinity;
      lista.forEach(function (tarjeta, i) {
        var centroTarjeta = tarjeta.offsetLeft + tarjeta.offsetWidth / 2;
        var distancia = Math.abs(centroTarjeta - centro);
        if (distancia < distanciaMinima) { distanciaMinima = distancia; indiceCercano = i; }
      });
      puntos.forEach(function (p, i) { p.classList.toggle('mc-activo', i === indiceCercano); });
    }

    prev.addEventListener('click', function () {
      actualizarFlechas();
      pista.scrollBy({ left: -paso(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      actualizarFlechas();
      pista.scrollBy({ left: paso(), behavior: 'smooth' });
    });
    puntos.forEach(function (punto, i) {
      punto.addEventListener('click', function () {
        var tarjeta = tarjetas()[i];
        if (!tarjeta) return;
        pista.scrollTo({ left: tarjeta.offsetLeft - (pista.clientWidth - tarjeta.offsetWidth) / 2, behavior: 'smooth' });
      });
    });
    pista.addEventListener('scroll', function () {
      actualizarFlechas();
      actualizarPuntos();
    }, { passive: true });

    // El ancho real de la pista puede no estar listo todavía en DOMContentLoaded
    // (fuentes o imágenes sin cargar) y dejar las flechas mal calculadas para
    // siempre, ya que solo se recalculan al hacer scroll. Se recalcula también
    // cuando todo termine de cargar y al cambiar el tamaño de la ventana.
    actualizarFlechas();
    actualizarPuntos();
    window.addEventListener('load', function () {
      actualizarFlechas();
      actualizarPuntos();
    });
    window.addEventListener('resize', function () {
      actualizarFlechas();
      actualizarPuntos();
    });
    pista.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', actualizarFlechas, { once: true });
      }
    });
  });
}

function initFaq() {
  document.querySelectorAll('[data-mc-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-mc-faq-pregunta]');
    var panel = item.querySelector('[data-mc-faq-respuesta]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var abierta = item.classList.contains('mc-abierta');
      item.closest('[data-mc-faq]').querySelectorAll('[data-mc-faq-item]').forEach(function (otro) {
        otro.classList.remove('mc-abierta');
        otro.querySelector('[data-mc-faq-respuesta]').style.maxHeight = null;
      });
      if (!abierta) {
        item.classList.add('mc-abierta');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}
